import mascot from "../assets/theCrew.png";
import boastGuardsLogo from "../assets/boastGuardsLogo.png";
import { useWindowDimensions } from "../hooks/useWindowDimensions";
import { StarworksButton } from "./StarworksButton";
import { YoutubeEmbed } from "./YoutubeEmbed";
import steamButton from "../assets/steam-store.png";

const LandingPageDesktop = () => {
  return (
    <div
      className="d-flex ocean-backdrop"
      style={{ gap: "1rem", padding: "0rem 10%", width: "100%" }}
    >
      {/* Left Side - Logo, Trailer, Steam Link */}
      <div style={{ flex: "1" }}>
        <div className="d-flex" style={{ justifyContent: "center" }}>
          <img
            src={boastGuardsLogo}
            className="img-responsive"
            style={{ maxWidth: "500px" }}
          />
        </div>
        <YoutubeEmbed embedId="d1YAIFKTK7Q?si=4nEfDYQS9kSlgLHZ" />
      </div>

      {/* Right Side - Mascot */}
      <div style={{ flex: "1" }}>
      <div
          className="d-flex"
          style={{ justifyContent: "center", padding: "1rem" }}
        >
          <a
            className="no-underline d-flex"
            style={{ justifyContent: "center" }}
            href="https://store.steampowered.com/app/3454840/Boast_Guards/"
            target="_blank"
          >
            <img
              src={steamButton}
              className="img-resposive"
              style={{ maxWidth: "50%",
                marginTop: "5vh",
                marginLeft: "10vh"}}
            />
          </a>
        </div>
        <div className="d-flex" style={{ justifyContent: "center" }}>
          <img
            src={mascot}
            className="img-responsive"
            style={{
              width: "100%", // Let it scale dynamically
              maxWidth: "1000px", // Increase potential max size
              marginTop: "30vh",
              marginLeft: "10vh",
              transform: "translateY(-50%)",
            }}
          />
        </div>
      </div>
    </div>
  );
};


const LandingPageMobile = () => {
  return (
    <div
      className="d-flex ocean-backdrop"
      style={{
        flexDirection: "column",
        gap: "1rem",
        padding: "2rem 10%",
        width: "100%",
      }}
    >
      <div className="d-flex" style={{ justifyContent: "center" }}>
        <img
          src={boastGuardsLogo}
          className="img-responsive"
          style={{ maxWidth: "550px" }}
        />
      </div>
      <div
        className="d-flex"
        style={{ justifyContent: "center", padding: "1rem" }}
      >
        <a
          className="no-underline d-flex"
          style={{ justifyContent: "center" }}
          href="https://store.steampowered.com/app/3454840/Boast_Guards/"
          target="_blank"
        >
          <img
            src={steamButton}
            className="img-resposive"
            style={{ maxWidth: "75%" }}
          />
        </a>
      </div>
      <YoutubeEmbed embedId="d1YAIFKTK7Q?si=4nEfDYQS9kSlgLHZ" />
    </div>
  );
};

export const LandingPage = () => {
  const screenSize = useWindowDimensions();

  if (screenSize.width < 990) return <LandingPageMobile />;
  return <LandingPageDesktop />;
};
